import { Spin } from "antd";

export default function BotonDivLeft2({ tituloBoton, onClick, loading }) {

  console.log({loading})
  return (
    <div onClick={onClick} className="botonCardLeft">
      {loading ? <Spin size="small" /> : <>{tituloBoton}</>}
    </div>
  );
}
